<template>
  <div v-if="item" class="mode15-box relative">
    <!-- {{ total }} -->
    <div class="mo15-content">
      <div class="content-desc" v-html='changeTarget($utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.desc)'></div>
    </div>
  </div>
</template>

<script>
import mode15 from "@/lobby_common/mixins_views/homeModule/mode15.js";
export default {
  mixins: [mode15],
};
</script>
<style lang="scss" scoped>
.mo15-content {
  overflow: hidden;
  padding-top: 15px;
  // margin-top: 12px;
  font-size: 16px;
  color: var(--font-color-200);
  word-wrap: break-word;
  @media (max-width: 768px) {
    padding: 10px 10px 0;
  }
  .content-desc{
    padding: 5px 15px;
    background: var(--background-800);
    border-radius: var(--radius-300);
    @media (max-width: 768px) {
      padding: 2px 10px;
    }
  }
}
</style>
